import type { TargetedMouseEvent } from 'preact';

import { toCamelCase } from './string';

const specialRoles = ['dialog', 'filter'];

type RoleHandler = (e: Event, cmRole: string, elementWithRole: HTMLElement) => void;
type DefinedHandlers = Partial<Record<string, RoleHandler>>;

export default function cmRoleHandler(e: Event, definedHandlers: DefinedHandlers): void {
  const { target } = e;
  if (!(target instanceof Element)) {
    return;
  }
  const elementWithRole = target.closest<HTMLElement>('[data-cm-role]');
  if (!elementWithRole) {
    return;
  }

  const { cmRole } = elementWithRole.dataset;
  if (!cmRole) {
    return;
  }

  const specialRole = specialRoles.find((r) => cmRole.startsWith(r));
  const handler = specialRole ? definedHandlers[specialRole] : definedHandlers[toCamelCase(cmRole)];

  if (handler) {
    handler(e, cmRole, elementWithRole);
  }
}

export const simpleHandler =
  (definedHandlers: DefinedHandlers) =>
  (e: TargetedMouseEvent<HTMLElement>): void =>
    cmRoleHandler(e, definedHandlers);
